import React, { useState } from "react";

import { close, logo, menu } from "../assets";

import { navLinks } from "../constants";

const Navbar = () => {
  // change nav color when scrolling

  const [color, setColor] = useState(false);
  const changeColor = () => {
    if (window.scrollY >= 95) {
      setColor(true);
    } else {
      setColor(false);
    }
  };

  window.addEventListener("scroll", changeColor);

  const [toggle, setToggle] = useState(false);
  return (
    <nav
      className={`w-[100%] flex py-6 px-6  justify-evenly items-center fixed z-[6] ${
        color ? "header-bg" : "header"
      }`}
    >
      <img className="w-[126px] h-[35px] sm:mx-12" src={logo} alt="hoobank" />

      <ul className="list-none mr-24 sm:flex hidden justify-end items-center flex-1">
        {navLinks.map((nav, index) => {
          return (
            <li
              key={nav.id}
              className={`font-serif font-normal cursor-pointer text-[1.2rem]  hover:text-teal-400 duration-300  ${
                index === navLinks.length - 1 ? "mr-0" : "mr-14"
              }  text-white`}
            >
              <a href={`#${nav.id}`}>{nav.title}</a>
            </li>
          );
        })}
      </ul>
      <div className="sm:hidden flex flex-1 justify-end items-center">
        <img
          src={toggle ? close : menu}
          alt="menu"
          className="w-[28px] h-[28px] object-contain cursor-pointer duration-2"
          onClick={() => setToggle((prev) => !prev)}
        />
        <div
          className={`${
            toggle ? "flex" : "hidden"
          } p-6 bg-black-gradient absolute top-20 right-0 mx-4 my-2 min-w-[140px] rounded-xl sidebar`}
        >
          <ul className="list-none flex flex-col justify-end items-center flex-1">
            {navLinks.map((nav, index) => (
              <li
                key={nav.id}
                className={`font-serif font-normal cursor-pointer text-[18px] ${
                  index === navLinks.length - 1 ? "mr-0" : "mb-4"
                }  text-white`}
              >
                <a href={`#${nav.id}`}>{nav.title}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
